import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Loader from '../../atoms/Loader'
import ParentRow from './ParentRow'
import BodyRow from './BodyRow'

import './style.scss'

const Body = ({ dataSource, withoutDataPlaceholder, onHandleExpand }) => {
  const [allRows, setAllRows] = useState()

  useEffect(() => {
    if (dataSource) {
      setAllRows(dataSource)
    }
  }, [dataSource])

  return (
    <div className="fil-table--body">
      {!allRows ? (
        <div className="fil-table--body-row--without-data">
          <div>
            <Loader />
          </div>
        </div>
      ) : _.isEmpty(allRows) ? (
        <div className="fil-table--body-row--without-data">
          <div>{withoutDataPlaceholder}</div>
        </div>
      ) : (
        allRows.map((row, rowIndex) => {
          const { parentNode } = row
          const RowComponent = !!parentNode ? ParentRow : BodyRow

          return (
            <RowComponent
              key={`table_row_${rowIndex}`}
              {...row}
              {...(!!parentNode
                ? {
                    onHandleExpand: (expanded) => {
                      onHandleExpand({ rowIndex, expanded })
                    }
                  }
                : {})}
            />
          )
        })
      )}
    </div>
  )
}

Body.propTypes = {
  dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withoutDataPlaceholder: PropTypes.string,
  isSelectable: PropTypes.bool,
  onHandleExpand: PropTypes.func
}

Body.defaultProps = {
  dataSource: null,
  withoutDataPlaceholder: 'No Data',
  isSelectable: false,
  onHandleExpand: () => {}
}

export default React.memo(Body)
